import { Injectable, OnDestroy } from '@angular/core';
import { CityService } from '@city/feature';
import { DeliveryZonesFacade } from '@delivery/data-access';
import { Subscription } from 'rxjs';

@Injectable()
export class DeliveryZonesLazyService implements OnDestroy {
  subscription = new Subscription();
  deliveryZones$ = this.deliveryZonesFacade.getDeliveryZones();

  private initialized = false;

  constructor(
    private deliveryZonesFacade: DeliveryZonesFacade,
    private cityService: CityService,
  ) {}

  init(): void {
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    this.subscription.add(
      this.cityService.activeBaseStoreCode$.subscribe(() => {
        this.deliveryZonesFacade.loadDeliveryZones();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
